export default __webpack_public_path__ + "static/media/Amanda.00c55dcd.png";